import { useCreateProduct } from "@/hooks/api-hooks";
import { Button, TextInput } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { gotoProduct } from "@/lib/navigation";

type Props = {
    onCreate?: () => void;
};

export default function ModalNewProduct({ onCreate }: Props): JSX.Element {
    const { t } = useTranslation();
    const createProduct = useCreateProduct();
    const [nameDraft, setNameDraft] = useState("");

    const canSave = nameDraft.trim().length > 0;

    const handleCreateProduct = () => {
        if (!canSave) return;
        createProduct.mutate(
            { name: nameDraft.trim() },
            {
                onSuccess: (response) => {
                    onCreate?.();
                    if (response.data?.id) {
                        gotoProduct(response.data.id);
                    }
                },
            }
        );
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter" && canSave) {
            handleCreateProduct();
        }
    };

    return (
        <div className="space-y-4">
            <TextInput
                label={t('product_name')}
                value={nameDraft}
                onChange={(e) => setNameDraft(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
            />
            <div className="flex justify-end mt-6">
                <Button
                    onClick={handleCreateProduct}
                    loading={createProduct.isPending}
                    disabled={!canSave}
                    size="xs"
                    color="black"
                    radius="lg"
                >
                    {t('save')}
                </Button>
            </div>
        </div>
    );
}
